<div class="container-fluid pt-3">
	<jhi-collapsible heading="{{translateService.instant('germplasm-details.files.heading')}}">
		<iframe [src]="safeUrl" style="border: 0" width="100%" height="600" scrolling="auto"></iframe>
	</jhi-collapsible>
</div>
